import "./libs/flexible";
import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import Comment from "./comment/index";
import Anted from "./share";
import store from "@/store/index";
import "./theme/theme-file.less";
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
const app = createApp(App);
app.use(router);
app.use(store);
Comment(app);
Anted.forEach((item) => {
  app.use(item);
});
app.mount("#app");
